import * as React from 'react';
import './loading.css'

export default function IApp ({}) {
    return (
      <div className="centerme">
        <div className="loader">Loading...</div>
      </div>
    );
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/spinner/loader.tsx